import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "digtal-box" }
const _hoisted_2 = { class: "item" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "t" }, "系统运行天数", -1)
const _hoisted_4 = { class: "num" }
const _hoisted_5 = { class: "item" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "t" }, "接入医疗机构", -1)
const _hoisted_7 = { class: "num" }
const _hoisted_8 = { class: "item" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "t" }, "累积接诊病例", -1)
const _hoisted_10 = { class: "num" }
const _hoisted_11 = { class: "item" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "t" }, "今日接诊", -1)
const _hoisted_13 = { class: "num" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_dv_digital_flop = _resolveComponent("dv-digital-flop")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_dv_digital_flop, { config: _ctx.startedDays }, null, 8, ["config"])
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _hoisted_6,
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_dv_digital_flop, { config: _ctx.totalHospital }, null, 8, ["config"])
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _hoisted_9,
      _createElementVNode("div", _hoisted_10, [
        _createVNode(_component_dv_digital_flop, { config: _ctx.totalNum }, null, 8, ["config"])
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _hoisted_12,
      _createElementVNode("div", _hoisted_13, [
        _createVNode(_component_dv_digital_flop, { config: _ctx.todayNum }, null, 8, ["config"])
      ])
    ])
  ]))
}